import { Skill } from "@hubcapp/types";

export const getCategoryProgressPercentage = (skills: Skill[]): number => {
  const categoryTotalScore = skills.reduce((total, skill) => {
    const newTotal = total + skill.score;
    return newTotal;
  }, 0);

  return skills.length
    ? Math.ceil((categoryTotalScore / (skills.length * 5)) * 100)
    : 0;
};
